import type { ModifierGroupType } from "schemas/modifiers";

import * as React from "react";

import { BackgroundModifier } from "@v1/components/editor/page/element-editor/components/modifiers/BackgroundModifier";
import BorderModifier from "@v1/components/editor/page/element-editor/components/modifiers/BorderModifier";
import EffectsModifier from "@v1/components/editor/page/element-editor/components/modifiers/EffectsModifier";
import { IconModifier } from "@v1/components/editor/page/element-editor/components/modifiers/IconModifier";
import ImageModifier from "@v1/components/editor/page/element-editor/components/modifiers/ImageModifier";
import ItemsModifier from "@v1/components/editor/page/element-editor/components/modifiers/ItemsModifier";
import LayoutModifier from "@v1/components/editor/page/element-editor/components/modifiers/LayoutModifier";
import PositioningModifier from "@v1/components/editor/page/element-editor/components/modifiers/PositioningModifier";
import { RowColumnSpanModifier } from "@v1/components/editor/page/element-editor/components/modifiers/RowColumnSpanModifier";
import SpacingModifier from "@v1/components/editor/page/element-editor/components/modifiers/SpacingModifier";
import TextStyleModifier from "@v1/components/editor/page/element-editor/components/modifiers/TextStyleModifier";
import VideoSourceModifier from "@v1/components/editor/page/element-editor/components/modifiers/VideoSourceModifier";
import { VisibilityModifier } from "@v1/components/editor/page/element-editor/components/modifiers/VisibilityModifier";
import { exhaustiveSwitch } from "replo-utils/lib/misc";

import FontAndColorModifier from "./modifiers/FontAndColorModifier";
import SizeModifier from "./modifiers/SizeModifier";

export const ModifierGroups: React.FC<
  React.PropsWithChildren<{ groupTypes: ModifierGroupType[] }>
> = ({ groupTypes }) => {
  return (
    <>
      {groupTypes.map((groupType) => (
        <React.Fragment key={groupType.type}>
          {exhaustiveSwitch(groupType)({
            rowColumnSpans: <RowColumnSpanModifier />,
            spacing: <SpacingModifier />,
            visibility: <VisibilityModifier />,
            textStyle: ({ includeTextEditor }) => (
              <TextStyleModifier includeTextEditor={includeTextEditor} />
            ),
            fontAndColor: ({
              allowsGradientSelection,
              allowsFontSelection,
            }) => (
              <FontAndColorModifier
                allowsGradientSelection={allowsGradientSelection}
                allowsFontSelection={allowsFontSelection}
              />
            ),
            size: <SizeModifier />,
            border: <BorderModifier />,
            positioning: <PositioningModifier />,
            background: <BackgroundModifier />,
            items: ({ field, title, allowedItemTypes }) => (
              <ItemsModifier
                allowedItemTypes={allowedItemTypes}
                title={title}
                field={field}
              />
            ),
            layout: () => <LayoutModifier />,
            effects: <EffectsModifier />,
            icon: <IconModifier />,
            imageSource: <ImageModifier />,
            videoSource: <VideoSourceModifier />,
          })}
        </React.Fragment>
      ))}
    </>
  );
};
